export default "__VITE_ASSET__vBjHhkbH__"